// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestedUserCard-cls1_ejI","cls2":"SuggestedUserCard-cls2_BFN SuggestedUserCard-cls1_ejI"};